import { FullTimeTag } from './FullTimeTag';

export default FullTimeTag;
